import React from "react";

import { UserProfile } from "../index.js";

export default React.memo(() => <UserProfile />);
